/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const CodeRuntime = {
  Python: "python",
  Python3: "python3",
  Javascript: "javascript",
  Node: "node",
  Go: "go",
  Bash: "bash",
  Shell: "shell",
  Sh: "sh",
} as const;
export type CodeRuntime = ClosedEnum<typeof CodeRuntime>;

/** @internal */
export const CodeRuntime$inboundSchema: z.ZodNativeEnum<typeof CodeRuntime> = z
  .nativeEnum(CodeRuntime);
/** @internal */
export const CodeRuntime$outboundSchema: z.ZodNativeEnum<typeof CodeRuntime> =
  CodeRuntime$inboundSchema;
